import AttachedImageModal from "@/components/Dashboard/AttachedImageModal";
import { postImage } from "@/api/DiaryApi";
import DashboardConstants from "@/store/constants/dashboardRecords";
import * as pdfjsLib from "pdfjs-dist";

export default {
  name: "AttachedImage",
  components: {
    AttachedImageModal
  },
  data() {
    return {
      isDrawPreviewPDFFirstTime: false
    };
  },
  updated(){
    if(!this.isDrawPreviewPDFFirstTime){
      this.drawPreviewImage()
    }
    this.isDrawPreviewPDFFirstTime = true
  },
  methods: {
    showAttachedImageModal() {
      this.$bvModal.show('attached-image-modal');
    },
    loadImage(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.readFile(files[0]);
    },
    readFile(file) {
      let reader = new FileReader();
      reader.onload = e => {
        if (this.validateFileName(file.name)) {
          this.postImage(e.target.result, { name: file.name, type: file.type });
        } else {
          this.$emit('changeType', 'messValidateFileUpload');
          this.$bvModal.show('bv-modal-mess');
        }
      };
      reader.readAsArrayBuffer(file);
    },
    async postImage(binaryStream, fileInfo) {
      const urlObj = await postImage(binaryStream, fileInfo)
      this.$store.commit(DashboardConstants.COMMIT.setUrlImage, urlObj.url);
      this.$store.commit(DashboardConstants.COMMIT.setPresignedUrlImage, urlObj.presignedUrl);
      this.$store.commit(DashboardConstants.COMMIT.setObjectKeyImage, urlObj.objectKey);
    },
    validateFileName(fileName) {
      const specialCharacters = ['#', '%', '+', '[', ']', '?'];
      for (const character of fileName) {
        if (specialCharacters.includes(character)) {
          return false;
        }
      }
      return true;
    },
    async drawPreviewImage(){
       // PDFJSStatic
       pdfjsLib.GlobalWorkerOptions.workerSrc = '//cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.js';
       if(this.attachedImage && this.isPDF){
         // Using DocumentInitParameters object to load url
         var loadingTask = pdfjsLib.getDocument({url: this.attachedImage});
         loadingTask.promise.then(function(pdf) {
           // Fetch the first page
           var pageNumber = 1;
           pdf.getPage(pageNumber).then(function(page) {
            var scale = 0.65;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById("pdfViewer");
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              // after rendered
              // swap canvas with image
              const canvasElementPreviewPDF = document.getElementsByClassName("attached-image-swap-embed")
              const imagePreviewPDF = document.createElement('img')
              if(canvasElementPreviewPDF.length>0){
                imagePreviewPDF.crossOrigin = "anonymous"
                imagePreviewPDF.src = canvasElementPreviewPDF[0].firstChild.toDataURL()
                imagePreviewPDF.style.width = "100%"
                canvasElementPreviewPDF[0].firstChild.replaceWith(imagePreviewPDF)
              }
            });
            //clear context after render canvas
            if (context) {
              context.clearRect(0, 0, canvas.width, canvas.height);
              context.beginPath();
            }
            });
         }, function (reason) {
           // PDF loading error
           console.error(reason);
         });
      }
    },
  },
  computed: {
    attachedImage() {
      return this.$store.getters[DashboardConstants.GETTERS.getAttachedPresignedUrl];
    },
    isNull() {
      const url = this.attachedImage;
      return (url == null || url == "");
    },
    isPDF() {
      const url = this.attachedImage;
      const urlIsPdf = url ? this.$_.last(url.split("."))?.includes("pdf") : false
      return urlIsPdf;
    },
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
  },
  watch: {
    attachedImage: function(){
      if(this.isDrawPreviewPDFFirstTime){
        this.drawPreviewImage()
      }
    }
  }
}
